export const cabListColumns = [
    {
      Header: 'Id',
      accessor: 'id',
    },
    {
      Header: 'Car',
      accessor: 'car',
    },
    {
      Header: 'Car Number',
      accessor: 'carNumber',
    },
    {
      Header: 'Car Type',
      accessor: 'carType',
    },
    {
      Header: 'Fuel Type',
      accessor: 'fuelType',
    },
    {
      Header: 'Seat Capacity',
      accessor: 'seatCapacity',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
  ];

  export const cabListTableData = [
    {   
        id:'01',
        car:'Innova',
        carNumber:'AB-GB-0158',
        carType: 'MPV',
        fuelType: 'Disel',
        seatCapacity: '8',
    },
    {   
        id:'02',
        car:'XUV 700',
        carNumber:'AB-GB-1158',
        carType: 'SUV',
        fuelType: 'Disel',
        seatCapacity: '5',
    },
    {   
        id:'03',
        car:'Maruti 800',
        carNumber:'AB-GB-1111',
        carType: 'Sedan',
        fuelType: 'Petrol',
        seatCapacity: '4',
    },
    {   
        id:'04',
        car:'Hyundai Verna',
        carNumber:'AB-GB-7711',
        carType: 'Sedan',
        fuelType: 'Petrol',
        seatCapacity: '4',
    },
    {   
        id:'05',
        car:'Maruti Dzire',
        carNumber:'AB-GB-9911',
        carType: 'Sedan',
        fuelType: 'Petrol',
        seatCapacity: '4',
    },
    {   
      id:'06',
      car:'Honda Amaze',
      carNumber:'AB-GB-1188',
      carType: 'Sedan',
      fuelType: 'Petrol',
      seatCapacity: '4',
    },
    {   
      id:'07',
      car:'Volkswagen Virtus',
      carNumber:'AB-GB-1112',
      carType: 'Sedan',
      fuelType: 'Petrol',
      seatCapacity: '4',
    },

]